import { z } from 'zod';
import { JOB_STATUSES } from '../constants.js';

// ─── Response schemas ─────────────────────────────────────────────────────────

export const JobResponseSchema = z.object({
  id: z.string().uuid(),
  runId: z.string().uuid(),
  userId: z.string().uuid(),
  status: z.enum(JOB_STATUSES),
  phase: z.string().nullable(),
  message: z.string().nullable(),
  startedAt: z.string().nullable(),
  updatedAt: z.string(),
  completedAt: z.string().nullable(),
  error: z.string().nullable(),
});
export type JobResponse = z.infer<typeof JobResponseSchema>;

export const ListJobsResponseSchema = z.object({
  ok: z.literal(true),
  items: z.array(JobResponseSchema),
  total: z.number().int().nonnegative(),
  limit: z.number().int().positive(),
  offset: z.number().int().nonnegative(),
});
export type ListJobsResponse = z.infer<typeof ListJobsResponseSchema>;
